import {createContext, useContext} from "react";
import {LoginStore} from "./login-store";
import {makeAutoObservable} from "mobx";
export * from "./api-config"




export class Store {
    formActiveStore: LoginStore  = new LoginStore();
    constructor() {
        makeAutoObservable(this);
    }
}


export const StoreContext = createContext<Store | null>(null);

export const useStore = () => {
    const context = useContext(StoreContext)

    if (!context) {
        throw new Error('Не найден провайдер')
    }

    return context
}

